import React from 'react';
import {injectIntl} from "react-intl";
import Picture from "../picture/Picture";

class Signature extends React.Component {

  render() {
    const {signature} = this.props;

    if (!signature) {
      return null;
    }

    return (
      <div>
        <Picture picture={signature}/>
      </div>
    );
  }
}

export default injectIntl(Signature);



// WEBPACK FOOTER //
// ./src/components/interventiondetail/reception/Signature.js